import { createAction } from "@reduxjs/toolkit";
import _ from "lodash";
import axios from "axios";
import { takeEvery, call, put, select } from "redux-saga/effects";
import buildUrl from "build-url-ts";
import { FetchPublicCourseErrorResponse, FetchPublicCourseRequest, FetchPublicCourseResponse, FetchPublicCoursesRequest } from "src/types/coaching/courses";
import { FETCH_PREFERENCES_SKILLS_REQUEST, FETCH_PUBLIC_COURSE_REQUEST, FETCH_PUBLIC_COURSES_REQUEST, FETCHING_PREFERENCES_SKILLS_FAILED, FETCHING_PREFERENCES_SKILLS_SUCCEEDED, FETCHING_PUBLIC_COURSE_FAILED, FETCHING_PUBLIC_COURSE_SUCCEEDED, FETCHING_PUBLIC_COURSES_FAILED, FETCHING_PUBLIC_COURSES_SUCCEEDED } from "../actionTypes";
import { FetchPreferencesSkillErrorResponse, FetchPreferencesSkillResponse } from "src/types/coaching/skills";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_COACHING_API_URL}`;

// fetch courses
export const fetchPublicCourse = createAction<FetchPublicCourseRequest>(FETCH_PUBLIC_COURSE_REQUEST);
const fetchPublicCourseSucceeded = createAction<FetchPublicCourseResponse>(FETCHING_PUBLIC_COURSE_SUCCEEDED);
const fetchPublicCourseFailed = createAction<FetchPublicCourseErrorResponse>(FETCHING_PUBLIC_COURSE_FAILED);

const fetchPublicCourseSaga = function* (action: ReturnType<typeof fetchPublicCourse>): any {
  const request = action.payload as FetchPublicCourseRequest;
  const id = request.id;

  const fetchPublicCoursesApi = () => {
    return axios({
      method: "GET",
      url: `${apiUrl}/api/1.0/courses/public/${id}`,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPublicCoursesApi);
    yield put(
      fetchPublicCourseSucceeded({
        course: response.course,
        learningRecord: response.learningRecord
      }),
    );
  } catch (error) {
    yield put(fetchPublicCourseFailed({id: id, error: error }));
  }
};

// fetch public courses
export const fetchPublicCourses = createAction<FetchPublicCoursesRequest>(FETCH_PUBLIC_COURSES_REQUEST);
const fetchingPublicCoursesSucceeded = createAction<any>(FETCHING_PUBLIC_COURSES_SUCCEEDED);
const fetchingPublicCoursesFailed = createAction<any>(FETCHING_PUBLIC_COURSES_FAILED);
const fetchPublicCoursesSaga = function* (action: ReturnType<typeof fetchPublicCourses>): any {

  const { courseType, page, limit } = action.payload as FetchPublicCoursesRequest;

  const fetchCoursesApi = () => {
    return axios({
      method: "GET",
      url: `${apiUrl}/api/1.0/explore/courses`,
      params: {
        courseType: courseType,
        page: page,
        limit: limit
      }
    }).then((response) => response.data);
  };
  try {
    const response = yield call(fetchCoursesApi);
    yield put(
      fetchingPublicCoursesSucceeded({
        courseType: courseType,
        response: response,
      }),
    );
  } catch (error) {
    yield put(fetchingPublicCoursesFailed({courseType: courseType, error: error }));
  }
};

//Fetch user preferences Skills
export const fetchPreferencesSkills = createAction<void>(FETCH_PREFERENCES_SKILLS_REQUEST);
const fetchingPreferencesSkillsSucceeded = createAction<FetchPreferencesSkillResponse>(FETCHING_PREFERENCES_SKILLS_SUCCEEDED);
const fetchingPreferencesSkillsFailed = createAction<FetchPreferencesSkillErrorResponse>(FETCHING_PREFERENCES_SKILLS_FAILED);

const fetchPreferencesSkillsSaga = function* (action: ReturnType<typeof fetchPreferencesSkills>): any {
  const url = buildUrl(apiUrl, {
    path: `api/1.0/explore/skill_preferences`,
  });
 
  const fetchSkillsAPI = () => {
    return axios({
      method: 'GET',
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchSkillsAPI);
    yield put(fetchingPreferencesSkillsSucceeded({
      response: response
    }));
  } catch (error) {
    yield put(fetchingPreferencesSkillsFailed({error: error }));
  }
};



export default function* exploreSaga() {
  yield takeEvery(FETCH_PUBLIC_COURSE_REQUEST, fetchPublicCourseSaga);
  yield takeEvery(FETCH_PUBLIC_COURSES_REQUEST, fetchPublicCoursesSaga);
  yield takeEvery(FETCH_PREFERENCES_SKILLS_REQUEST, fetchPreferencesSkillsSaga);
}
